export default {
    root: function (_a) {
        var context = _a.context;
        return ({
            class: [
                // Positioning & Background
                'tw-absolute tw-bg-transparent !tw-z-[2000]',
                // Padding (placement based)
                {
                    'tw-py-0 tw-px-1': (context === null || context === void 0 ? void 0 : context.right) || (context === null || context === void 0 ? void 0 : context.left) || (!(context === null || context === void 0 ? void 0 : context.right) && !(context === null || context === void 0 ? void 0 : context.left) && !(context === null || context === void 0 ? void 0 : context.top) && !(context === null || context === void 0 ? void 0 : context.bottom)),
                    'tw-py-1 tw-px-0': (context === null || context === void 0 ? void 0 : context.top) || (context === null || context === void 0 ? void 0 : context.bottom),
                },
            ],
        });
    },
    arrow: function (_a) {
        var context = _a.context;
        return ({
            class: [
                // Positioning & Size
                'tw-absolute tw-size-0',
                // Border
                'tw-border-transparent tw-border-solid',
                // Placement-Based Arrow Styling
                {
                    'tw--mt-1 tw-border-y-[0.25rem] tw-border-r-[0.25rem] tw-border-l-0 tw-border-r-zinc-900': (context === null || context === void 0 ? void 0 : context.right) || (!(context === null || context === void 0 ? void 0 : context.right) && !(context === null || context === void 0 ? void 0 : context.left) && !(context === null || context === void 0 ? void 0 : context.top) && !(context === null || context === void 0 ? void 0 : context.bottom)),
                    'tw--mt-1 tw-border-y-[0.25rem] tw-border-l-[0.25rem] tw-border-r-0 tw-border-l-zinc-900': context === null || context === void 0 ? void 0 : context.left,
                    'tw--ml-1 tw-border-x-[0.25rem] tw-border-t-[0.25rem] tw-border-b-0 tw-border-t-zinc-900': context === null || context === void 0 ? void 0 : context.top,
                    'tw--ml-1 tw-border-x-[0.25rem] tw-border-b-[0.25rem] tw-border-t-0 tw-border-b-zinc-900': context === null || context === void 0 ? void 0 : context.bottom,
                },
            ],
        });
    },
    text: {
        class: [
            // Font
            'tw-font-sans tw-text-white',
            // Typography
            'tw-text-md tw-text-center',
            'tw-whitespace-pre-line tw-break-words',
            // Spacing & Layout
            'tw-px-2 tw-py-1',
            // Styling & Background
            'tw-bg-zinc-900 tw-rounded-md tw-shadow-md tw-max-w-80',
        ],
    },
};
